import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["active", "chip", "description", "href", "icon", "name", "sx"];
import * as React from 'react';
import NextLink from 'next/link';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ROUTES from 'docs/src/route';
import PageContext from 'docs/src/modules/components/PageContext';
import SvgMuiLogomark from 'docs/src/icons/SvgMuiLogomark';
import SvgBaseUiLogo from 'docs/src/icons/SvgBaseUiLogo';
import BackupTableRoundedIcon from '@mui/icons-material/BackupTableRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var iconStyles = function iconStyles(theme) {
  return {
    fontSize: '.875rem',
    color: (theme.vars || theme).palette.primary.main
  };
};
var logoColor = function logoColor(theme) {
  return {
    '& path': _extends({}, theme.applyDarkStyles({
      fill: (theme.vars || theme).palette.primary[400]
    }))
  };
};
var NavLabel = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.spacing(0.5, 1, 0.5, 1),
    fontSize: theme.typography.pxToRem(11),
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'uppercase',
    letterSpacing: '.1rem',
    color: (theme.vars || theme).palette.text.tertiary
  };
});
function ProductItem(_ref2) {
  var active = _ref2.active,
    chip = _ref2.chip,
    description = _ref2.description,
    href = _ref2.href,
    icon = _ref2.icon,
    name = _ref2.name,
    _ref2$sx = _ref2.sx,
    sx = _ref2$sx === void 0 ? [] : _ref2$sx,
    other = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/_jsxs(MenuItem, _extends({
    component: NextLink // using the Next link directly here as it accepts, as opposed to the docs Link, passing role="menuitem"
    ,
    role: "menuitem",
    href: href,
    sx: [function (theme) {
      return _extends({
        p: 1,
        pl: '6px',
        display: 'flex',
        alignItems: 'start',
        gap: '8px',
        flexGrow: 1,
        backgroundColor: active ? alpha(theme.palette.primary[50], 0.8) : undefined,
        border: '1px solid',
        borderColor: active ? 'primary.100' : 'transparent',
        borderRadius: '8px',
        transition: '100ms ease-in background-color, border',
        textDecorationLine: 'none',
        '&:hover': {
          backgroundColor: active ? alpha(theme.palette.primary[50], 0.8) : 'grey.50',
          borderColor: 'divider'
        },
        '&.Mui-focusVisible': {
          backgroundColor: active ? (theme.vars || theme).palette.primary[50] : 'transparent'
        }
      }, theme.applyDarkStyles({
        backgroundColor: active ? alpha(theme.palette.primary[900], 0.2) : undefined,
        borderColor: active ? alpha(theme.palette.primary[300], 0.2) : 'transparent',
        '&:hover': {
          backgroundColor: active ? alpha(theme.palette.primary[900], 0.3) : alpha(theme.palette.primaryDark[700], 0.5)
        },
        '&.Mui-focusVisible': {
          backgroundColor: active ? alpha(theme.palette.primary[900], 0.5) : 'transparent'
        }
      }));
    }].concat(_toConsumableArray(Array.isArray(sx) ? sx : [sx]))
  }, other, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        height: 21,
        // match the Typography line-height
        width: 21,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: icon
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          color: "text.primary",
          variant: "body2",
          fontWeight: "semiBold",
          children: name
        }), chip]
      }), /*#__PURE__*/_jsx(Typography, {
        color: "text.secondary",
        fontSize: ".813rem",
        children: description
      })]
    })]
  }));
}
var coreProducts = [{
  id: 'material-ui',
  name: 'Material UI',
  description: 'Comprehensive foundational components.',
  icon: /*#__PURE__*/_jsx(SvgMuiLogomark, {
    width: 14,
    height: 14,
    sx: logoColor
  }),
  href: ROUTES.materialDocs
}, {
  id: 'base-ui',
  name: 'MUI Base',
  description: 'Unstyled components and hooks.',
  icon: /*#__PURE__*/_jsx(SvgBaseUiLogo, {
    width: 14,
    height: 14,
    sx: logoColor
  }),
  href: ROUTES.baseDocs
}, {
  id: 'joy-ui',
  name: 'Joy UI',
  description: 'Delightful modern components.',
  icon: /*#__PURE__*/_jsx(WebRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.joyDocs
}, {
  id: 'system',
  name: 'MUI System',
  description: 'Ergonomic CSS utilities.',
  icon: /*#__PURE__*/_jsx(StyleRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.systemDocs
}];
var advancedProducts = [{
  id: 'x-data-grid',
  name: 'Data Grid',
  description: 'Fast and extensible data table.',
  icon: /*#__PURE__*/_jsx(BackupTableRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.dataGridOverview
}, {
  id: 'x-date-pickers',
  name: 'Date and Time Pickers',
  description: 'Date, time, and range components.',
  icon: /*#__PURE__*/_jsx(CalendarMonthRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.datePickersOverview
}, {
  id: 'x-charts',
  name: 'Charts',
  description: 'Data visualization components.',
  icon: /*#__PURE__*/_jsx(BarChartRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.chartsOverview
}, {
  id: 'x-tree-view',
  name: 'Tree View',
  description: 'Hierarchical list components.',
  icon: /*#__PURE__*/_jsx(AccountTreeRoundedIcon, {
    sx: iconStyles
  }),
  href: ROUTES.treeViewOverview
}];
var MuiProductSelector = /*#__PURE__*/React.forwardRef(function MuiProductSelector(props, forwardedRef) {
  var pageContext = React.useContext(PageContext);
  return /*#__PURE__*/_jsxs(MenuList, _extends({}, props, {
    component: "div",
    ref: forwardedRef,
    sx: {
      p: 1,
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(1, minmax(0, 1fr))',
        sm: 'repeat(2, minmax(0, 1fr))'
      },
      gap: '4px'
    },
    children: [coreProducts.map(function (product) {
      return /*#__PURE__*/_jsx(ProductItem, {
        name: product.name,
        description: product.description,
        href: product.href,
        icon: product.icon,
        active: pageContext.productId === product.id
      }, product.name);
    }), /*#__PURE__*/_jsx(Divider, {
      sx: {
        mx: -1,
        gridColumn: {
          xs: '1 / span 1',
          sm: '1 / span 2'
        }
      }
    }), /*#__PURE__*/_jsx(Box, {
      role: "none",
      sx: {
        gridColumn: {
          xs: '1 / span 1',
          sm: '1 / span 2'
        }
      },
      children: /*#__PURE__*/_jsx(NavLabel, {
        children: "MUI X Components"
      })
    }, "X components"), advancedProducts.map(function (product) {
      return /*#__PURE__*/_jsx(ProductItem, {
        name: product.name,
        description: product.description,
        icon: product.icon,
        href: product.href,
        active: pageContext.productId === product.id
      }, product.name);
    })]
  }));
});
if (false) MuiProductSelector.displayName = "MuiProductSelector";
export default MuiProductSelector;